import { subscribeToNewsletter } from './checkout';
import { fieldValidation } from '../utils/string';
import { fetchData } from '../utils/async';

export const CHANGE_DEVICE = 'CHANGE_DEVICE';
export const COOKIE_CONSENT = 'COOKIE_CONSENT';

export const INIT = 'INIT';
export const SITE_INIT = 'SITE_INIT';
export const SET_QUERY = 'SET_QUERY';

export const OPEN_MENU = 'OPEN_MENU';
export const OPEN_CART = 'OPEN_CART';

export const INPUT_FIELD_UPDATE = 'INPUT_FIELD_UPDATE';
export const FORM_SUBMITTED = 'FORM_SUBMITTED';

export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

export const UPDATE_EVENT_DETAILS = 'UPDATE_EVENT_DETAILS';
export const UPDATE_EVENT_DETAILS_ERRORS = 'UPDATE_EVENT_DETAILS_ERRORS';

export const PARTICIPANTS_REGISTERED = 'PARTICIPANTS_REGISTERED';
export const PARTICIPANTS_ERROR = 'PARTICIPANTS_ERROR';

export const ACUITY_IFRAME_HEIGHT = 'ACUITY_IFRAME_HEIGHT';

/*
	USER SETTINGS
*/
export const changeDevice = (breakPoint) => ({ type: CHANGE_DEVICE, breakPoint });
export const cookieConsent = (consent) => ({ type: COOKIE_CONSENT, consent });

/*
	ACUITY
*/
export const setIframeHeight = (height) => ({ type: ACUITY_IFRAME_HEIGHT, height });

/*
	INTERACTION EVENTS
*/

export const openMenu = (open) => ({ type: OPEN_MENU, open });

/*
	NAVIGATION
*/

export const goToPage = (path) => (dispatch, getState) => {
	let { language } = getState().environment.setup;
	const languages = Object.keys(getState().environment.setup.languages);
	const extra = {};
	const pathSections = path.split('/').reduce((acc, section) => {
		// Allow purposely changing language.
		if (languages.indexOf(section) !== -1) {
			language = section;
			return acc;
		}
		if (section !== '' && section !== language) {
			if (section.indexOf('#') !== -1) {
				extra.hash = section.slice(section.indexOf('#') + 1);
				section = section.slice(0, section.indexOf('#'));
			}
			return [...acc, section];
		}
		return acc;
	}, []);

	if (language !== getState().environment.setup.language) {
		dispatch({ type: CHANGE_LANGUAGE, language });
	}
	if (pathSections[0] === 'selection') {
		if (pathSections.length === 1) return dispatch({ type: 'SELECTION', payload: { ...extra } });
		if (pathSections[1] === 'tracking') return dispatch({ type: 'SELECTION_TRACKING', payload: { ...extra } });
	}
	if (pathSections[0] === 'logout' && pathSections.length === 1) {
		return dispatch({ type: 'LOG_OUT', payload: { language } });
	}
	if (pathSections.length === 0) {
		return dispatch({ type: 'START', payload: { language } });
	}
	return dispatch({ type: 'CATEGORY_PRODUCT_PAGE', payload: { language, path: pathSections.join('/'), ...extra } });
};

export const preloadPage = (path) => (dispatch, getState) => {
	const paths = !Array.isArray(path) ? [path] : path;

	paths.forEach((p) => {
		if (!getState().pageData[p]) {
			fetchData(p).then((data) => (
				dispatch({ type: 'PAGE_DATA', data, page: p })
			)).catch((err) => console.log(err));
		}
	});
};

/*
	FORM EVENTS
*/

export const inputFieldUpdate = (field, section, value, valid) => ({ type: INPUT_FIELD_UPDATE, field, section, value, valid });

export const formSubmitted = (section) => ({ type: FORM_SUBMITTED, section });

/*
	TRANSITION EVENTS
*/

export const removeNotification = (notificationType, notificationName) => ({ type: REMOVE_NOTIFICATION, notificationType, notificationName });

/*
	FILTER ACTIONS
*/

export const updateFilter = (filterArray, force = false, setup = {}, currentPath = '') => ({ type: 'FILTER', filterArray, force, setup, currentPath });

export const clearFilter = () => ({ type: 'CLEAR_FILTER' });

export const clearSort = () => ({ type: 'CLEAR_SORT' });

export const resetFilter = () => ({ type: 'RESET_FILTER' });

export const rebaseFilter = (setup, currentPath) => ({ type: 'REBASE_FILTER', setup, currentPath });

export const searchInput = (text) => ({ type: 'SEARCH', text });

/*
	PAGINATION
*/

export const updatePagination = (currentPath, currentPage) => ({ type: 'UPDATE_PAGINATION', currentPath, currentPage });

/*
	FAVOURITES
*/

export const toggleFavourite = (productId, currentPath) => (dispatch, getState) => {
	const { favourites, setup } = getState().environment;
	const product = getState().productCache[setup.market][setup.pricelist].products[productId];

	if (favourites.indexOf(productId) === -1) {
		if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
		window.dataLayer.push({ values: null });
		window.dataLayer.push({
			event: 'AddToWishlist',
			values: {
				value: product.price.priceAsNumber,
				currency: setup.countries[setup.country].currency,
				content_name: product.name,
				content_category: currentPath,
				content_ids: product.groupId,
			},
		});
		window.dataLayer.push({ ecommerce: null });
		window.dataLayer.push({
			event: 'add_to_wishlist',
			ecommerce: {
				value: product.price.priceAsNumber,
				currency: setup.countries[setup.country].currency,
				items: [{
					item_id: product.groupId,
					item_name: product.name,
				}],
			},
		});
	}
	return dispatch({ type: 'TOGGLE_FAVOURITE', productId });
};

/*
	LANGUAGE
*/

export const changeLanguage = (language) => ({ type: CHANGE_LANGUAGE, language });

/*
	MAGAZINE LIST
*/

export const retrieveListing = (section, page = false) => (dispatch) => (
	fetchData(`listing/${section}${page ? `/${page}` : ''}`).then((data) => (
		dispatch({ type: 'LISTING', data, section })
	)).catch((err) => console.log(err))
);

/*
	EVENTS
*/

export const updateEventDetails = (id, value) => ({ type: UPDATE_EVENT_DETAILS, id, value });

export const updateEventDetailsErrors = (id, value) => {
	const fieldType = id === 'email' ? 'email' : 'text';
	const error = fieldValidation(value, fieldType);

	return ({ type: UPDATE_EVENT_DETAILS_ERRORS, id, error });
};

export const registerParticipants = (path, fields) => (dispatch, getState) => {
	const eventDetails = getState().environment.eventDetails;
	const skip = ['allowFriends', 'acceptTerms', 'subscribeToNewsletter'];
	const participants = [];
	const reCaptcha = window.grecaptcha.getResponse();
	let hasErrors = false;

	// Return errors if defined.
	Object.keys(fields).forEach((field) => {
		if (eventDetails[field] === undefined || fieldValidation(eventDetails[field], fields[field])) {
			dispatch({ type: UPDATE_EVENT_DETAILS_ERRORS, id: field, error: true });
			hasErrors = true;
		}
	});

	if (!eventDetails.acceptTerms) dispatch({ type: UPDATE_EVENT_DETAILS_ERRORS, id: 'acceptTerms', error: true });
	if (!reCaptcha) dispatch({ type: UPDATE_EVENT_DETAILS_ERRORS, id: 'reCaptcha', error: true });
	if (hasErrors || !eventDetails.acceptTerms || !reCaptcha) return dispatch({ type: PARTICIPANTS_ERROR });

	// Subscribe to newsletter if needed.
	if (eventDetails.subscribeToNewsletter && /\S/.test(eventDetails.email)) {
		dispatch(subscribeToNewsletter(eventDetails.email));
	}

	// Package details before sending.
	Object.keys(eventDetails).forEach((participantDetail) => {
		if (skip.indexOf(participantDetail) === -1) {
			const whooseDetail = participantDetail.indexOf('Friend') !== -1 && eventDetails.allowFriends ? 1 : 0;
			if (participants[whooseDetail] === undefined) participants[whooseDetail] = {};
			participants[whooseDetail][participantDetail.replace('Friend', '')] = eventDetails[participantDetail];
		}
	});

	// Update CMS with users.
	fetchData(`event/${path}`, { participants, acceptTerms: eventDetails.acceptTerms, reCaptcha }).then((data) => {
		if (!data.success) return dispatch({ type: PARTICIPANTS_ERROR, errors: data.errors });
		return dispatch({ type: PARTICIPANTS_REGISTERED });
	}).catch((err) => console.log(err));
};
